// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-select-dropdown {
  background-color: #000 !important;
  border-style: solid;
  border-width: 1px;
  border-color: #fff;
}
.nkl-select-item-option,
.nkl-select-item-option-content {
  color: #fff;
  background-color: transparent !important;
}
.nkl-select-item-option:hover,
.nkl-select-item-option-content:hover,
.nkl-select-item-option:active,
.nkl-select-item-option-content:active,
.nkl-select-item-option:focus,
.nkl-select-item-option-content:focus {
  color: #000;
  background-color: #1aebff !important;
}
.nkl-select-item-option-selected {
  color: #000 !important;
  background-color: #1aebff !important;
}
.nkl-layout {
  height: 100vh;
}
.nkl-layout .main-content {
  background-color: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  padding-top: 5px;
}
.nkl-layout .main-content h1 {
  color: #fff;
}
@media (max-width: 480px) {
  .nkl-layout .main-content {
    width: 100%;
  }
}
.nkl-layout .nkl-btn {
  background-color: #fff;
  border-color: #000;
  color: #000;
}
.nkl-layout .nkl-btn:hover,
.nkl-layout .nkl-btn:active,
.nkl-layout .nkl-btn:focus {
  background-color: #1aebff;
  border-color: #000;
  color: #000;
}
.nkl-layout .nkl-btn:disabled {
  background-color: #292929;
  border-color: #605E5C;
  color: #605E5C;
}
.nkl-layout .nkl-btn:disabled:hover,
.nkl-layout .nkl-btn:disabled:active,
.nkl-layout .nkl-btn:disabled:focus {
  background-color: #292929;
  border-color: #605E5C;
  color: #605E5C;
}
.nkl-layout .app-code-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.nkl-layout .ecard-hatch {
  margin-top: -15px;
}
.nkl-layout .ecard-hatch .ant-col-1 {
  flex: none;
  padding-left: 5px;
}
.nkl-layout .ecard-drawer,
.nkl-layout .upload-drawer {
  display: none;
}
.nkl-layout .ecard-drawer.open,
.nkl-layout .upload-drawer.open {
  max-width: 500px;
  margin-left: -34px;
  padding-left: 34px;
  padding-right: 34px;
  top: 0px;
  height: 100%;
  overflow: hidden;
  background-color: #000;
  display: block;
}
.nkl-layout .ecard-drawer.open .back-btn,
.nkl-layout .upload-drawer.open .back-btn {
  background-color: #1aebff;
  border-color: #1aebff;
}
.nkl-layout .ecard-drawer.open .bold-header,
.nkl-layout .upload-drawer.open .bold-header {
  color: #fff;
}
.nkl-layout .ecard-drawer.open .ecard-back,
.nkl-layout .upload-drawer.open .ecard-back {
  background-color: #1aebff;
}
.nkl-layout .ecard-drawer.open .upload-content,
.nkl-layout .upload-drawer.open .upload-content {
  background-color: #fff;
  color: #000;
}
.nkl-layout .ecard-drawer.open .upload-content .parameter-text,
.nkl-layout .upload-drawer.open .upload-content .parameter-text {
  color: #000;
}
.nkl-layout .ecard-drawer.open .ecard-list,
.nkl-layout .upload-drawer.open .ecard-list {
  height: auto;
  padding-left: 0px;
  padding-right: 0px;
  justify-content: flex-start;
}
.nkl-layout .render-image {
  padding-right: 20px;
}
.nkl-layout .nkl-checkbox-wrapper {
  color: #fff;
}
.nkl-layout .nkl-checkbox-input,
.nkl-layout .nkl-checkbox-inner {
  background-color: #fff;
  border-color: #1aebff !important;
}
.nkl-layout .nkl-checkbox-checked .nkl-checkbox-inner {
  background-color: #1aebff;
}
.nkl-layout .budget-meter-container .nkl-progress-bg {
  background-color: #1aebff;
  border-radius: 3px;
}
.nkl-layout .budget-meter-container .nkl-progress-inner {
  border-radius: 3px;
}
.nkl-layout .budget-meter-container .header-text {
  font-size: 12pt;
  font-weight: bold;
}
.nkl-layout .budget-meter-container .footer-container {
  display: flex;
  flex-direction: row;
}
.nkl-layout .budget-meter-container .footer-container .primary-footer-text {
  font-size: 10pt;
}
.nkl-layout .budget-meter-container .footer-container .secondary-footer-text {
  font-size: 10pt;
  margin-left: auto;
}
.nkl-layout .success-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.nkl-layout .success-container .message {
  padding-top: 17px;
  font-size: 20px;
  color: #1aebff;
}
.nkl-layout .success-container .bubble-container {
  top: 50px;
  height: 465px;
  width: 100%;
  position: absolute;
  overflow: hidden;
}
.nkl-layout .success-container .bubbles {
  display: flex;
  align-items: flex-end;
  height: 100%;
}
.nkl-layout .success-container .bubble {
  position: absolute;
  width: 40px;
  height: 40px;
  background: #f1f1f1;
  border-color: #bebed8;
  border-style: solid;
  border-width: 1px;
  border-radius: 50%;
  opacity: 0.5;
  animation: rise 10s infinite ease-in;
}
.nkl-layout .success-container .bubble:nth-child(1) {
  width: 40px;
  height: 40px;
  left: 10%;
  bottom: -100px;
  animation-duration: 8s;
}
.nkl-layout .success-container .bubble:nth-child(2) {
  width: 20px;
  height: 20px;
  left: 20%;
  bottom: -100px;
  animation-duration: 5s;
  animation-delay: 1s;
}
.nkl-layout .success-container .bubble:nth-child(3) {
  width: 50px;
  height: 50px;
  left: 35%;
  bottom: -100px;
  animation-duration: 7s;
  animation-delay: 2s;
}
.nkl-layout .success-container .bubble:nth-child(4) {
  width: 80px;
  height: 80px;
  left: 50%;
  bottom: -100px;
  animation-duration: 11s;
  animation-delay: 0s;
}
.nkl-layout .success-container .bubble:nth-child(5) {
  width: 35px;
  height: 35px;
  left: 55%;
  bottom: -100px;
  animation-duration: 6s;
  animation-delay: 1s;
}
.nkl-layout .success-container .bubble:nth-child(6) {
  width: 45px;
  height: 45px;
  left: 65%;
  bottom: -100px;
  animation-duration: 8s;
  animation-delay: 3s;
}
.nkl-layout .success-container .bubble:nth-child(7) {
  width: 90px;
  height: 90px;
  left: 70%;
  bottom: -100px;
  animation-duration: 12s;
  animation-delay: 2s;
}
.nkl-layout .success-container .bubble:nth-child(8) {
  width: 25px;
  height: 25px;
  left: 80%;
  bottom: -100px;
  animation-duration: 6s;
  animation-delay: 2s;
}
.nkl-layout .success-container .bubble:nth-child(9) {
  width: 15px;
  height: 15px;
  left: 70%;
  bottom: -100px;
  animation-duration: 5s;
  animation-delay: 1s;
}
.nkl-layout .success-container .bubble:nth-child(10) {
  width: 90px;
  height: 90px;
  left: 25%;
  bottom: -100px;
  animation-duration: 10s;
  animation-delay: 4s;
}
@keyframes rise {
  0% {
    bottom: -100px;
    transform: translateY(0);
  }
  50% {
    transform: translate(100px);
  }
  100% {
    bottom: 100%;
    transform: translateY(-800px);
  }
}
.nkl-layout .success-icon {
  color: #1aebff;
}
.nkl-avatar.behavior-image {
  margin-right: 12px;
  background: transparent;
}
.recognize .anticon svg {
  fill: #000;
}
.recognize .nkl-input,
.recognize .nkl-input-number {
  background-color: #fff;
  border-style: none;
  color: #000;
}
.recognize .nkl-input:hover,
.recognize .nkl-input-number:hover,
.recognize .nkl-input:active,
.recognize .nkl-input-number:active,
.recognize .nkl-input:focus,
.recognize .nkl-input-number:focus {
  background-color: #fff;
  box-shadow: none;
  border-bottom-color: #1aebff;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.recognize .nkl-popover .nkl-popover-arrow-content {
  --antd-arrow-background-color: #000;
  background-color: #000;
}
.recognize .nkl-popover .nkl-popover-inner {
  background-color: #000;
  border-color: #fff;
  border-style: solid;
  border-width: 1px;
}
.recognize .nkl-popover .nkl-popover-inner .nkl-popover-inner-content {
  color: #fff;
}
.recognize .slide-in-enter {
  opacity: 0.01;
  transform: translateX(50%);
}
.recognize .slide-in-enter-active {
  opacity: 1;
  transform: translateX(0%);
  transition: all 500ms ease-out;
}
.recognize .slide-in-enter-done {
  opacity: 1;
}
.recognize .slide-in-exit {
  opacity: 1;
  transform: translateX(0%);
}
.recognize .slide-in-exit.slide-in-exit-active {
  opacity: 0;
  transform: translateX(-50%);
  transition: all 500ms ease-out;
}
.recognize .slide-in-exit-done {
  opacity: 0;
}
.recognize .slide-out-enter {
  opacity: 0.01;
  transform: translateX(-50%);
}
.recognize .slide-out-enter-active {
  opacity: 1;
  transform: translateX(0%);
  transition: all 500ms ease-out;
}
.recognize .slide-out-enter-done {
  opacity: 1;
}
.recognize .slide-out-exit {
  opacity: 1;
  transform: translateX(0%);
}
.recognize .slide-out-exit.slide-out-exit-active {
  opacity: 0;
  transform: translateX(50%);
  transition: all 500ms ease-out;
}
.recognize .slide-out-exit-done {
  opacity: 0;
}
.recognize .main-content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.recognize .anticon-close-circle {
  background-color: #fff;
}
.recognize .bread-crumb-container {
  display: flex;
  flex-direction: row;
  border-bottom-width: 1pt;
  border-top-width: 1pt;
  border-color: #fff;
  border-top-style: solid;
  border-bottom-style: solid;
  margin-bottom: 28px;
}
.recognize .bread-crumb-container .nkl-popover {
  width: 350px;
  padding-top: 0;
}
.recognize .bread-crumb-container .nkl-popover .nkl-popover-inner {
  margin-left: 6px;
  margin-bottom: 6px;
  border-radius: 12px;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}
.recognize .bread-crumb-container .bread-crumb-header {
  color: #fff;
  display: flex;
  flex-direction: row;
  padding-top: 10pt;
  padding-bottom: 10pt;
}
.recognize .bread-crumb-container .bread-crumb-button {
  border-style: none;
  background-color: #000;
  color: #fff;
}
.recognize .bread-crumb-container .bread-crumb-button .anticon svg {
  fill: #fff;
}
.recognize .bread-crumb-container .bread-crumb-button .button-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.recognize .bread-crumb-container .bread-crumb-button .button-content .button-text {
  padding-right: 5px;
  font-size: 8pt;
}
.recognize .bread-crumb-container .bread-crumb-button .button-content .rotate-icon {
  transform: rotate(90deg);
  width: 12px;
  height: 12px;
}
.recognize .bread-crumb-container .errors {
  border-bottom-color: #CC4A31;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.recognize .next-button {
  margin-left: auto;
}
.recognize .back-button {
  background-color: #fff;
  color: #000;
  border-color: #000;
}
.recognize .back-button .back-button-icon {
  width: 14px;
  height: 14px;
}
.recognize .content-container {
  flex: 1;
  overflow: auto;
  padding-right: 34px;
  padding-left: 34px;
  padding-bottom: 20px;
}
.recognize .button-container {
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 34px;
  padding-left: 34px;
}
.recognize .input-label {
  font-size: 18px;
  font-weight: bold;
}
.recognize .input-label-extra {
  font-size: 16px;
}
.recognize .results-container {
  margin-top: 2rem;
}
.recognize .results-container .select-text {
  margin-bottom: 15px;
}
.recognize .selected-recipients-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 10pt;
  padding-bottom: 10pt;
}
.recognize .selected-recipient-item {
  height: 17pt;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
  color: #000;
  border-radius: 10pt;
  margin-bottom: 5pt;
  margin-right: 5pt;
}
.recognize .selected-recipient-item .recipient-name {
  font-size: 10;
  padding-left: 5pt;
}
.recognize .selected-recipient-item .recipient-remove {
  margin-left: auto;
}
.recognize .search-container {
  padding-bottom: 10.5px;
}
.recognize .search-container .search-input {
  background-color: #fff;
}
.recognize .search-container .search-input .nkl-input:hover,
.recognize .search-container .search-input .nkl-input:active,
.recognize .search-container .search-input .nkl-input:focus {
  border-bottom-style: none;
}
.recognize .search-container .search-input.nkl-input-affix-wrapper-focused,
.recognize .search-container .search-input .nkl-input-affix-wrapper:focus {
  border-bottom-color: #1aebff;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.recognize .search-container .nkl-popover {
  width: 320px;
  padding-top: 0;
}
.recognize .search-container .nkl-popover .nkl-popover-inner {
  margin-left: 6px;
  margin-bottom: 6px;
  border-radius: 12px;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  height: 400px;
}
.recognize .search-container .search-results .nkl-popover-inner-content {
  height: 400px;
  overflow: auto;
}
.recognize .recipient-item {
  display: flex;
  flex-direction: row;
  padding: 6px;
}
.recognize .recipient-item .recipient-info {
  padding-left: 5pt;
  padding-right: 10px;
}
.recognize .recipient-item .recipient-info .recipient-name {
  font-size: 14px;
}
.recognize .recipient-item .recipient-info .recipient-email {
  font-size: 10px;
}
.recognize .recipient-item .recipient-info .recipient-additionalInfo {
  font-size: 8pt;
  color: #b2262b;
}
.recognize .recipient-item .recipient-info .recipient-error {
  font-size: 10px;
  color: #b2262b;
}
.recognize .recipient-item .recipient-points {
  margin-left: auto;
}
.recognize .clickable {
  cursor: pointer;
}
.recognize .clickable:hover {
  color: #000;
  background-color: #1aebff;
}
.recognize .recipient-error {
  background-color: #FDF6F4;
}
.recognize .recipient-error:hover {
  background-color: #FDF6F4;
}
.recognize .divider {
  background-color: #fff;
  height: 1pt;
  margin-left: 0px;
  margin-right: 0px;
}
.recognize .team-container {
  padding-top: 16.5px;
}
.recognize .team-container .team-select-text {
  font-size: 12px;
  padding-bottom: 22px;
}
.recognize .program-list {
  padding-top: 14px;
}
.recognize .program-list .nkl-card-body {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 16px;
  padding-right: 13px;
}
.recognize .program-list .program-item {
  background-color: #000;
  color: #fff;
  flex: 1;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  margin-bottom: 8px;
}
.recognize .program-list .program-item .program-top-card {
  display: flex;
  flex-direction: row;
}
.recognize .program-list .program-item .program-top-card .program-info .program-name {
  font-size: 16px;
}
.recognize .program-list .program-item .program-top-card .program-select {
  margin-left: auto;
}
.recognize .program-list .program-item .program-top-card .program-select .anticon svg {
  fill: #1aebff;
}
.recognize .program-list .program-item .program-top-card .program-select .nkl-spin-spinning {
  padding-right: 5px;
}
.recognize .program-list .program-item .program-top-card .program-select .nkl-spin-dot-item {
  background-color: #1aebff;
}
.recognize .program-list .program-item .program-bottom-card {
  justify-content: center;
  font-size: 12px;
}
.recognize .program-list .program-item .program-bottom-card .program-budget {
  display: flex;
  flex-direction: row;
}
.recognize .program-list .program-item .program-bottom-card .program-budget .available-label {
  font-size: 10pt;
  font-weight: bold;
}
.recognize .program-list .program-item .program-bottom-card .program-budget .reward-text {
  padding-left: 3pt;
  font-size: 10pt;
  font-weight: lighter;
}
.recognize .program-list .program-item .program-bottom-card .error-item {
  margin-right: -13px;
  margin-left: -16px;
  margin-bottom: -6px;
  padding-left: 16px;
  padding-right: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #fdf6f4;
  color: #ad1b05;
  font-weight: bold;
}
.recognize .program-list .program-item:hover {
  cursor: pointer;
}
.recognize .program-list .program-item-selected {
  border-color: #1aebff;
}
.recognize .points-available {
  margin-left: 3px;
}
.recognize .behavior-section {
  padding-top: 24px;
}
.recognize .behavior-section .behavior-select-container {
  flex: 1;
  padding-bottom: 15pt;
}
.recognize .behavior-section .behavior-select-container .behavior-select {
  width: 200pt;
  background-color: #fff;
  color: #000;
}
.recognize .behavior-section .behavior-select-container .behavior-select:hover,
.recognize .behavior-section .behavior-select-container .behavior-select:active,
.recognize .behavior-section .behavior-select-container .behavior-select:focus {
  border-color: #1aebff;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.recognize .behavior-section .behavior-select-container .behavior-select .nkl-select-selection-item {
  display: flex;
  align-items: center;
}
.recognize .awards-container {
  padding-bottom: 20px;
}
.recognize .awards-container .error-text {
  color: #CC4A31;
}
.recognize .awards-container .slider-text {
  font-size: 8pt;
  font-weight: lighter;
  line-height: 0pt;
}
.recognize .awards-container .allocate-points {
  padding-top: 15pt;
}
.recognize .awards-container .allocate-points .nkl-checkbox-inner {
  border-color: #1aebff;
}
.recognize .awards-container .allocate-points .nkl-checkbox-checked .nkl-checkbox-inner {
  background-color: #1aebff;
}
.recognize .awards-container .points-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10pt;
}
.recognize .awards-container .points-container .points-label {
  padding-top: 3pt;
  padding-bottom: 3pt;
  padding-left: 5pt;
  padding-right: 5pt;
  border-color: #fff;
  border-width: 1pt;
  border-left-width: 0pt;
  border-style: solid;
}
.recognize .awards-container .point-range {
  font-size: 8pt;
  font-weight: lighter;
}
.recognize .awards-container .allocate-points-container {
  padding-top: 10pt;
}
.recognize .awards-container .allocate-points-container .recipient-point-row {
  display: flex;
  padding-top: 5pt;
  flex-direction: row;
  align-items: center;
  padding-bottom: 5pt;
}
.recognize .awards-container .allocate-points-container .recipient-point-row .recipient-info {
  padding-left: 5pt;
}
.recognize .awards-container .allocate-points-container .recipient-point-row .recipient-info .recipient-name {
  font-size: 12pt;
}
.recognize .awards-container .allocate-points-container .recipient-point-row .recipient-info .recipient-additionalInfo {
  font-size: 8pt;
  font-weight: lighter;
}
.recognize .awards-container .allocate-points-container .recipient-point-row .point-entry {
  margin-left: auto;
}
.recognize .message-container .private-container {
  padding-top: 10px;
}
.recognize .message-container .ecards-container {
  padding-top: 10px;
  padding-bottom: 10px;
}
.recognize .message-container .ecards-container .select-ecard {
  cursor: pointer;
  max-width: 100%;
  border-radius: 6px;
}
.recognize .message-container .ecards-container .select-ecard:hover,
.recognize .message-container .ecards-container .select-ecard:active,
.recognize .message-container .ecards-container .select-ecard:focus {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.recognize .message-container .ecard-preview {
  display: flex;
}
.recognize .message-container .ecard-preview .select-ecard {
  max-width: 100%;
  border-radius: 6px;
}
.recognize .message-container .ecard-button-container {
  display: flex;
  padding-top: 30pt;
  justify-content: space-around;
}
.recognize .message-container .ecard-image-selected {
  display: flex;
  position: relative;
  width: 190px;
  border-radius: 8px;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}
.recognize .message-container .ecard-image-selected .nkl-image {
  width: 100%;
  border-radius: 8px;
  display: block;
}
.recognize .message-container .ecard-image-selected .close-icon {
  position: absolute;
  margin-left: 115pt;
  border-radius: 16px;
  margin-top: 5pt;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 2px;
}
.recognize .review-container {
  padding-top: 20px;
}
.recognize .review-container .divider {
  border-bottom-style: solid;
  border-bottom-color: #fff;
  border-bottom-width: 1px;
  margin-bottom: 20px;
}
.recognize .review-container .section-container {
  padding-top: 5pt;
  padding-bottom: 5pt;
}
.recognize .review-container .section-container .section-header {
  display: flex;
  flex-direction: row;
}
.recognize .review-container .section-container .section-header .edit-section {
  margin-left: auto;
}
.recognize .review-container .section-container .recipient-list {
  padding-top: 5pt;
}
.recognize .review-container .section-container .recipient-list .recipient-point-row {
  display: flex;
  padding-top: 5pt;
  flex-direction: row;
  padding-bottom: 5pt;
}
.recognize .review-container .section-container .recipient-list .recipient-point-row .recipient-info {
  padding-left: 5pt;
}
.recognize .review-container .section-container .recipient-list .recipient-point-row .recipient-info .recipient-name {
  font-size: 12pt;
}
.recognize .review-container .section-container .recipient-list .recipient-point-row .recipient-info .recipient-additionalInfo {
  font-size: 8pt;
  font-weight: lighter;
}
.recognize .review-container .section-container .recipient-list .recipient-point-row .point-entry {
  margin-left: auto;
}
.recognize .review-container .section-container .budget-slider {
  padding-bottom: 10pt;
}
.recognize .review-container .section-container .behavior-section {
  display: flex;
  flex-direction: row;
  font-size: 10pt;
  font-weight: bold;
  align-items: center;
  padding-bottom: 10px;
  min-width: max-content;
}
.recognize .review-container .section-container .behavior-section .behavior-name {
  padding-left: 5px;
}
.recognize .review-container .section-container .personalization-container {
  display: flex;
  flex-direction: row;
  padding-top: 10pt;
  padding-bottom: 10pt;
}
.recognize .review-container .section-container .personalization-container .message-privacy-container {
  display: flex;
  flex-direction: column;
}
.recognize .review-container .section-container .personalization-container .messagge-section {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 10pt;
}
.recognize .review-container .section-container .personalization-container .privacy-section {
  margin-top: auto;
  font-size: 8pt;
  font-weight: lighter;
}
.recognize .review-container .section-container .personalization-container .ecard-image {
  max-width: 100%;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
